'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paths = require('./paths');

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, person_id) {
  return function (dispatch, getState) {
    var registrations = (0, _paths.getRegistrationsForPerson)(getState(), feis_id, person_id);

    var accountBalance = 0;

    if (registrations) {
      var account_id = registrations.get('accountId');
      accountBalance = getState().getIn([feis_id, 'accounts', account_id, 'balance']);
    }

    if (registrations && accountBalance > 0) {
      return;
    }

    return dispatch(_defineProperty({
      feis_id: feis_id,
      person_id: person_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisRegistrationsForPersonUrl)(feis_id, person_id)
      },
      types: ['GET_REGISTERED_DATA_FOR_PERSON_START', 'GET_REGISTERED_DATA_FOR_PERSON', 'GET_REGISTERED_DATA_FOR_PERSON_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/registrations/getRegistrations.js
// module id = 156
// module chunks = 0